import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

// Define a type for the slice state
interface AppStateData {
  initialized: boolean;
}

// Define the initial state using that type
const initialState: AppStateData = {
    initialized: false,
};

export const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setInitStatus: (state, action: PayloadAction<any>)  => {
      state.initialized = action.payload;
    },
  },
})

export const { setInitStatus } = appStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectIsInitStatus = (state: RootState) => state.appState.initialized;

export default appStateSlice.reducer;